import React, { Component } from 'react';

class ScheduleGradeVacationsTab extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',        
      },
      redirect_url: false,
      loaded: 0,
      vacations_remaining: this.props.vacations_remaining,
    };

  }
  // LM
  componentWillReceiveProps(newProps) {
    if((this.state.loaded === 0 && Array.isArray(newProps.vacations_remaining)) || (this.state.loaded === 1 && newProps.updated === 1)) {
      this.setState({
        vacations_remaining: newProps.vacations_remaining,
        loaded: 1,
      });
    }
  }
  
  

  render() {
    var self = this;
    return (
<div>
  <h3 className="page-title">Férias previstas</h3>
  <hr/>
  {(this.state.vacations_remaining === null || typeof this.state.vacations_remaining === 'undefined') ?  <div><small><em>Nenhuma férias restante.</em></small><hr/></div> 
  : 
  <div>
    <table className="table table-bordered table-stripped table-hover">
      <thead>
        <tr>
          <th className="text-center">Tripulante</th>
          <th className="text-center">Início</th>
          <th className="text-center">Fim</th>
        </tr>
      </thead>
      <tbody id="suppliers-certifications">
        {Object.keys(self.state.vacations_remaining).map(function(k) {
          return (
            <tr>
              <td>{self.state.vacations_remaining[k].name}</td>
              <td className="text-center">{self.state.vacations_remaining[k].diaria_str}</td>
              <td>{self.state.vacations_remaining[k].fullname}</td>
            </tr>
          );
        })}
      </tbody>
    </table>
    <hr/>
  </div>
  }

</div>
    );
  }
}


export default ScheduleGradeVacationsTab;



// WEBPACK FOOTER //
// ./src/Components/ScheduleGrades/Elements/ScheduleGradeVacationsTab.js